import { render } from "./RelatorioProjecaoFinanceiraIndex.vue?vue&type=template&id=4a07fd82&scoped=true&ts=true"
import script from "./RelatorioProjecaoFinanceiraIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioProjecaoFinanceiraIndex.vue?vue&type=script&lang=ts"

import "./RelatorioProjecaoFinanceiraIndex.vue?vue&type=style&index=0&id=4a07fd82&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a07fd82"]])

export default __exports__